export default __webpack_public_path__ + "static/media/error-table-icon.2ed9c99a.svg";